import React from 'react';

function FlowMeter() {
  return (
    <>
      <style>{`
        .flowmeter-wrapper {
          padding: 2rem;
          background-color: #f9fafc;
          font-family: 'Segoe UI', sans-serif;
        }

        .flowmeter-content {
          max-width: 850px;
          margin: auto;
          background-color: #fff;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .flowmeter-content h1 {
          font-size: 2.4rem;
          text-align: center;
          color: #2c3e50;
          margin-bottom: 1.5rem;
        }

        .flowmeter-content img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 1.5rem auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          clip-path: inset(0 2px 3px 0);
        }

        .flowmeter-content p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #444;
          margin-bottom: 1rem;
        }

        @media (max-width: 768px) {
          .flowmeter-content h1 {
            font-size: 2rem;
          }

          .flowmeter-wrapper {
            padding: 1rem;
          }

          .flowmeter-content {
            padding: 1.2rem;
          }
        }
      `}</style>

      <main className="flowmeter-wrapper">
        <section className="flowmeter-content">
          <h1>Flow Meter</h1>
          <img src="fm.png" alt="Flow Meter" />
          <p>
            Back pressure compensated flow-meter with precise step-less control of flow make it
            suitable for administration of supplementary level of oxygen through nasal cannula, simple
            face mask, partial rebreathing mask, partial breathing mask, Non-re-breather mask,
            Resuscitation mask and bag valve mask.
          </p>
          <p>
            The attached bubble humidifier bottle ensures optimal humidity to mitigate dryness
            experienced during administration.
          </p>
          <p>
            Flowmeters are available in the Standard Thorpe style of Oxygen (Adult & Paediatric) & Medical
            Air which can be connected through DISS or Quick Connect adapters.
          </p>
        </section>
      </main>
    </>
  );
}

export default FlowMeter;
